
import Vue from 'vue';
import { contactName } from '@/helpers/contactName';
import { convertToArabicNumber } from '@/helpers/convertToArabicNumber';
import { dateFormat } from '@/helpers/dateFormat';

export default Vue.extend({
  props: {
    input: { type: Object, default: () => {} },
    data: { type: Object, default: () => {} },
    getVariable: { type: Function, default: () => () => {} },
    callFunction: { type: Function, default: () => () => {} },
    onChange: { type: Function, default: () => {} },
    parent: { type: Object, default: () => {} }
  },
  computed: {
    quotationDetails: function() : any {
      return this.getVariable(this.input.variable);
    },
    customerDetails: function(): any {
      return this.getVariable(this.input.config.customerDetailsVariable);
    },
    quotationValidity: function(): string {
      return this.parent._resolveFormulaValue('fn(ADD_DAYS,{{__item.createdAt}},15)', { _item: this.quotationDetails });
    },
    contactName: function(): string {
      return this.quotationDetails.contact ? contactName(this.quotationDetails.contact) : '';
      
    }
  },
  methods: {
    convertToArabicNo: function(numValue: number): string {
      return convertToArabicNumber(numValue);
    },
    formatDate: function(date: string, format?: string) {
      return dateFormat(date, format);
    }
  }
})
